module.exports = __webpack_public_path__ + "596a83295089cbfbcaec10a15aff9e23.png";